import React, { Fragment, useEffect, useRef, useState, } from "react";
import { v4 as uuidv4 } from "uuid";
import { RawTooltip } from "./Tooltip";
export var EllipseContent = function (_a) {
    var children = _a.children, tip = _a.tip, placement = _a.placement, _b = _a.lines, lines = _b === void 0 ? 1 : _b;
    var ref = useRef(null);
    var ellipseActive = useIsEllipseActive(ref, tip);
    var tipID = uuidv4();
    return (React.createElement(Fragment, null,
        placement !== "bottom" && ellipseActive && (React.createElement(RawTooltip, { content: tip, placement: placement, anchorId: "anchor_".concat(tipID) })),
        React.createElement("span", { id: "anchor_".concat(tipID), className: "ellipse-content", "data-tip": true, "data-for": tipID, ref: ref, style: { WebkitLineClamp: lines, lineClamp: lines } }, children),
        placement === "bottom" && ellipseActive && (React.createElement(RawTooltip, { content: tip, placement: "bottom", anchorId: "anchor_".concat(tipID) }))));
};
export var EllipseWrapper = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { style: {
            overflow: "hidden",
            display: "block",
        } }, children));
};
export function useIsEllipseActive(ref, tip) {
    var _a = useState(false), ellipseActive = _a[0], setEllipseActive = _a[1];
    var isEllipsisActive = function (e) { return e.offsetWidth < e.scrollWidth; };
    useEffect(function () {
        var component = ref.current;
        if (tip && component) {
            if (component.offsetHeight < component.scrollHeight ||
                component.offsetWidth < component.scrollWidth) {
                setEllipseActive(true);
            }
            ref.current && isEllipsisActive(ref.current) && setEllipseActive(true);
        }
    }, [ref.current]);
    return ellipseActive;
}
